module.exports = __webpack_public_path__ + "static/img/yt-logo.cf44b21.png";


//////////////////
// WEBPACK FOOTER
// ./static/assets/image/yt-logo.png
// module id = QU8n
// module chunks = 1 2 3 4 5 6